import axios, { AxiosInstance } from 'axios';

export class HttpService {
    private _axios: AxiosInstance;

    constructor(url: string) {
        this._axios = axios.create({
            baseURL: url,
        });
    }

    private get axios() {
        this.setAuthHeader();
        return this._axios;
    }

    private setAuthHeader() {
        const user = this.currentUser();
        if (user) {
            this._axios.defaults.headers.Authorization = 'Bearer ' + user.access_token;
        } else {
            this._axios.defaults.headers.Authorization = '';
        }
    }

    private getJwtPayload(t: string) {
        return JSON.parse(window.atob(t.split('.')[1]));
    }

    public currentUser(): any {
        const token = localStorage.getItem("access_token");
        if (token) {
            const user = this.getJwtPayload(token);
            user.access_token = token;
            return user;
        }
        return null;
    }

    public get(path: any, config?: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.axios.get(path, config).then((result) => {
                resolve(result);
            }).catch((e) => {
                reject();
            });
        });
    }

    public post(path: any, data: any, config?: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.axios.post(path, data, config).then((result) => {
                resolve(result);
            }).catch((e) => {
                reject();
            });
        });
    }

    public delete(path: any, config?: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.axios.delete(path, config).then((result) => {
                resolve(result);
            }).catch((e) => {
                reject();
            });
        });
    }
}
